<!--  -->
<template>
  <base-section id="home-hero" class="py-6 py-md-12">
    <v-responsive min-height="30vh">
      <v-container>
        <v-row align="center">
          <v-col cols="12">
            <v-responsive>
              <v-carousel
                :progress="true"
                :continuous="true"
                :show-arrows="false"
                vertical-delimiters="right"
                :cycle="true"
                hide-delimiter-background
                delimiter-icon="mdi-minus"
                height="600"
              >
                <v-carousel-item v-for="(slide, i) in slides" :key="i">
                  <v-sheet :color="colors[i]" height="100%" tile>
                    <v-row class="fill-height" align="center" justify="center">
                      <div class="display-3">{{ slide }} Slide</div>
                    </v-row>
                  </v-sheet>
                </v-carousel-item>

              </v-carousel>
            </v-responsive>
          </v-col>
        </v-row>
      </v-container>
    </v-responsive>
  </base-section>
</template>

<script>
export default {
  name: "HomeHero",
  components: {},

  data: () => ({
    colors: [
      "green",
      "secondary",
      "yellow darken-4",
      "red lighten-2",
      "orange darken-1"
    ],
    slides: ["First", "Second", "Third", "Fourth", "Fifth"]
  }),

  computed: {},

  methods: {},

  mounted() {}
};
</script>

<style lang='sass' scoped>
 #home-hero
    background: linear-gradient(to bottom, #1867c0, #5CBBF6)

</style>